<template>
    <div class="contact dark_bg pb-10">
        <Header v-bind:header="header"></Header>

        <v-container>
          <v-row class="mb-4 text-md-left">
            <v-col :cols="col3"  v-bind:key="id" v-for="(c,id) in contacts">
              <div class="contactName text-lowercase">{{c.name}}</div>
              <a class="contactEmail text-lowercase" :href='"mailto:" + c.email'>{{c.email}}</a>
            </v-col>
          </v-row>
          <v-row class="credits text-md-left">
            <v-col>
              FOTOCREDITS: <span class="names">Hylmar Möckel, Lothar Werthschulte, Arnd Geise & Martin Wieprecht</span>
            </v-col>
          </v-row>
          <v-row class="text-md-left">
            <v-col :cols="cols" class="add mb-xs-4 pl-xs-4 pr-xs-4">
                <!-- <em> -->
                {{info}}
                <!-- </em> -->
            </v-col>
            <v-col class="text-md-left">
              <div class="contactName text-lowercase">{{agent.name}}</div>
              <a class="contactEmail text-lowercase" :href='"mailto:" + agent.email'>{{agent.email}}</a>
              <div class="adress">
                <div >{{agent.adress.street}}</div>
                <div>{{agent.adress.zip}}</div>
                <div>{{agent.adress.phone}}</div>
              </div>
            </v-col>
          </v-row>
        </v-container>
    </div>
</template>


<script>
import Header from './Header.vue'

export default {
  name: 'Contact',
  components: {
    Header
  },
  computed : {
    cols () {
      const {mdAndDown } = this.$vuetify.breakpoint
      return mdAndDown ? 12 : 8
    },
    col3 () {
      const {smAndDown } = this.$vuetify.breakpoint
      return smAndDown ? 12 : 4
    },
  },
  data() {
      return {
          header: "Kontakt",
          contacts: [
            {
              id: 1,
              name: "Volker Präkelt",
              email: "Volker.praekelt@mediendeck.de"
            },
            {
              id: 2,
              name: "San Glaser",
              email: "dutchlandmusic@gmx.de"
            },
            {
              id: 3,
              name: "Sascha Rotermund",
              email: "rotermundsascha@gmail.com"
            }
          ], 
          agent: {
            name: "Susanne Kolleck",
            email: "kontakt@susannekolleck.org",
            adress: {
              street: "Maikäferpfad 26",
              zip: "14055 Berlin",
              phone: "Telefon: +49-30-663 88 95"
            }
          },
          info: "JAZZTERDAYS wird außerdem vertreten durch Konzertagentin Susanne Kolleck"
      }
  }
}
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap');

  .contactName {
    color: #707070;
    font-size: 2rem;
    font-family: 'Teko', sans-serif;
  }

  .contactEmail {
    text-decoration: none;
    color: #1765B3;
  }

  .adress {
    color: #707070;
  }

  .add {
    color: #707070;
  }

  .credits {
    color: #707070;

    .names {
        font-family: 'Teko', sans-serif;
    }
  }
</style>